import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ROUTES_MAP } from './routes-config';
import { COMPANIES_LIST } from './companies.config';

@Injectable()
export class Config {
  pages: any = ROUTES_MAP;
  cpmaniesList: any = COMPANIES_LIST;

  namePattern: string = [
    '^(([a-zA-ZÅåÄäÖöØøÆæÉéÈèÜüÊêÛûÎî]{0,}([a-zA-ZÅåÄäÖöØøÆæÉéÈèÜüÊêÛûÎî\'\\-]+)' +
    '?[a-zA-ZÅåÄäÖöØøÆæÉéÈèÜüÊêÛûÎî][\'\\.]?)\\s+)+',
    '(([a-zA-ZÅåÄäÖöØøÆæÉéÈèÜüÊêÛûÎî]{0,}([a-zA-ZÅåÄäÖöØøÆæÉéÈèÜüÊêÛûÎî\'\\-]+)' +
    '?[a-zA-ZÅåÄäÖöØøÆæÉéÈèÜüÊêÛûÎî][\'\\.]?)\\s{0,})$'
  ].join('');
  emailPattern: string = [
    '^(([^<>()[\\]\\\.,;:\\s@\\"]+(\\.[^<>()[\\]\\\.,;:\\s@\\"]+)*)|',
    '(\\".+\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|',
    '(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'
  ].join('');
  ssnPattern = '^[0-9]{11}$';
  yearPattern = '^[0-9]{4}$';
  zipCodePattern = '^[0-9]{4}$';
  phonePattern = '^(0047|\\+47)?\\d{8}$';
  phonePatternShort = '[0-9]{8}$';
  dobPattern = '^(0?[1-9]|[12][0-9]|3[01])(0[1-9]|1[0-2])([0-9]{2})$';
  carRegNumberPattern = /[a-zA-Z]{2}\d{5}/;
  mainPage = this.pages.profile;

  signinUrl = '/api/public/authenticate';
  signInAzureUrl = '/api/public/authenticate/microsoft';
  sessionsDataUrl = '/api/private/admin/sessions';
  invitationsMyPageDataUrl = '/api/private/admin/my-page/invites';
  offerDataUrl = '/api/private/admin/offers';
  sessionInfoUrl = '/api/private/admin/sessions/{sessionId}';
  offerInfoUrl = '/api/private/admin/offers/{offerId}';
  sessionFilesUrl = '/api/private/admin/sessions/{sessionId}/documents';
  offerFilesUrl = '/api/private/admin/offers/{offerId}/documents';
  offerTableFilterDataUrl = '/api/private/admin/offers/filter';
  setOfferAssigneeUrl = '/api/private/admin/offers/{offerId}/assignee';
  companyProfilesUrl = '/api/private/admin/profiles';
  companyProfilesOfferUrl = '/api/private/admin/offers/{offerId}/profiles';
  offerSaleSessionlUrl = '/api/private/user/offers/actions/init-offer-sale-session';
  offerNotificationSaleSessionlUrl = '/api/private/user/offers/{offerId}/actions/offer-notification';
  offerCompleteNotificationlUrl = '/api/private/offer/{offerId}/reminder';
  changeOfferProductUrl = '/api/private/user/offers/{offerId}/products';
  changeOfferUrl = '/api/private/user/offers/{id}/actions/recalculate-edit-offer';

  validationRulesUrl = '/api/private/admin/validations';
  validationRulesSearchUrl = '/api/private/admin/validations/search';
  offerEmailUrl = '/api/private/admin/offers/{offerId}/forward';
  userDataUrl = '/api/private/admin/profile/me';
  dataListUrl = '/api/private/admin/validations/datalists';
  editOfferStatusUrl = '/api/private/user/offers/{offerId}/actions/edit-offer-session-status';
  changeOfferCommentUrl = '/api/private/user/offers/{offerId}/actions/edit-offer-session-comment';
  updateOfferMetadataUrl = '/api/private/user/offers/{offerId}/actions/update-offer-session-metadata';
  offerAllFilesUrl = '/api/private/admin/offers/{offerId}/documents/all';
  changePasswordUrl = '/api/public/admin/users/actions/set-user-password';
  usersDataUrl = '/api/private/admin/users';
  resetUserPasswordUrl = '/api/public/admin/users/actions/reset-user-password';
  editOfferSessionUrl = '/api/private/user/offers/{offerId}/actions/edit-offer-session-customer-data';
  scoreDiscountUrl = '/api/private/admin/offers/{shortGuid}/uwscore';
  requestScoreDiscountV2Url = '/api/private/admin/offers/{shortGuid}/uwscore/requestV2';
  requestScoreDiscountUrl = '/api/private/admin/offers/{shortGuid}/uwscore/request';
  agentCompaniesUrl = '/api/private/admin/agent-companies';
  agentPrivateOfferTextUrl = '/api/private/admin/agent-companies/private-text/offers/{offerShortGuid}';
  offerHistoryChangesUrl = '/api/private/admin/offers/{offerId}/flows';
  offerEventsUrl = '/api/private/user/offers/{offerId}/actions/get-offer-events';
  getStatusRoadmapUrl = '/api/private/user/offers/{offerId}/actions/get-status-roadmap';
  offerCommentsUrl = '/api/private/user/offers/{offerId}/comments';
  offerDeclineReasonsUrl = '/api/private/offers/{shortGuid}/decline-reasons';
  previousCompaniesUrl = '/api/private/admin/previous-companies';
  ofvVariantsApiUrl = '/api/private/car/{carRegNo}/ofv/variants';
  carInfoApiUrl = '/api/private/car/{carRegNo}/ofv/info';
  carBrandsApiUrl = '/api/private/car/brands';
  carModelsApiUrl = '/api/private/car/brands/{brandId}/models';
  carModelRegYearsApiUrl = '/api/private/car/brands/{brandId}/models/{modelId}/reg-years';
  carModelYearsApiUrl = '/api/private/car/brands/{brandId}/models/{modelId}/reg-years/{regYearId}/model-years';
  carModelVariantApiUrl = '/api/private/car/brands/{brandId}/models/{modelId}/reg-years/{regYearId}/model-years/{modelYearId}/variants';
  brokrPartnerListUrl = '/api/private/admin/offers/{offerId}/partners';
  offerPermissionsUrl = '/api/private/admin/offers/{offerId}/permissions';
  permissionsUrl = '/api/private/admin/permissions';
  updateTiaPriceUrl = '/api/private/user/offers/{offerId}/actions/tia-offer-calculation';
  offerFetchOfferPriceUrl = '/api/private/user/offers/{offerId}/request-price-calculation';
  sseSubscribeUrl = '/api/private/sse/subscribe';
  saveEditProductTiaUrl = '/api/private/user/offers/{offerId}/actions/save-edit-offer';
  randPrimeUrl = '/api/private/user/offers/{offerId}/actions/update-rand-prime';
  defaultPropertiesUrl = '/api/private/companies/defaults';
  dynamicPropertiesUrl = '/api/private/companies/dynamic-properties';
  focusAcceptUrl = '/api/private/user/offers/{offerId}/actions/manual-accept';
  hierarchyKonseptsUrl = '/api/private/admin/hierarchy/konsepts';
  hierarchyGrupperingerUrl = '/api/private/admin/hierarchy/konsepts/{konsept}/grupperinger';
  hierarchyTypesUrl = '/api/private/admin/hierarchy/grupperinger/{gruppering}/types';
  hierarchyDefaultsUrl = '/api/private/admin/hierarchy/defaults';
  accessTokenKey = 'ingsvAdmaccessToken';

  // Environment configs
  production: boolean;
  baseUrl: string;
  crawlerUrl: string;
  app: string;
  contemiCPSlogic: boolean;
  redirectUrl: string;

  constructor() {
    const appConfig = environment;
    Object.assign(this, appConfig);
  }
}
